import { useCallback, useEffect, useRef } from "react";

import { WebConfig } from "config";
import { ClientInstance } from "utils/axios-instance";
import { buildPortalPresencePayload } from "./presence";

const HEARTBEAT_INTERVAL_MS = 60 * 1000;

const PortalPresence = ({ profile }) => {
    const requestInProgress = useRef(false);
    const userName = profile?.email?.trim();

    const sendHeartbeat = useCallback(() => {
        if (!userName || document.visibilityState === "hidden" || requestInProgress.current) {
            return Promise.resolve();
        }

        requestInProgress.current = true;
        return ClientInstance.post(
            `${WebConfig.serviceUrls.RestApi}${WebConfig.ApiUrls.presenceHeartbeat}`,
            buildPortalPresencePayload(userName),
            {
                timeout: 10000,
                skipGlobalLoader: true,
                handleErrorLocally: true,
            },
        )
            .catch(() => {
                // Presence is best-effort and must never interrupt portal use.
            })
            .finally(() => {
                requestInProgress.current = false;
            });
    }, [userName]);

    useEffect(() => {
        if (!userName) {
            return undefined;
        }

        sendHeartbeat();
        const interval = window.setInterval(sendHeartbeat, HEARTBEAT_INTERVAL_MS);
        const sendWhenVisible = () => {
            if (document.visibilityState === "visible") {
                sendHeartbeat();
            }
        };
        document.addEventListener("visibilitychange", sendWhenVisible);

        return () => {
            window.clearInterval(interval);
            document.removeEventListener("visibilitychange", sendWhenVisible);
        };
    }, [sendHeartbeat, userName]);

    return null;
};

export default PortalPresence;
